module.exports = __webpack_public_path__ + "ee69097ca54bc7349ba3141455c066c0.png";